module.exports = __webpack_public_path__ + "img/valuationPic.0ed4f1f0.png";